<template>
    <div class="container">
        <DataAtual/>
        <b-breadcrumb :items="$route.meta.breadcrumb"></b-breadcrumb>
        <b-card
            class="p-1 mb-3 bg-white rounded"
            header-bg-variant="transparent"
            header-class="text-center"
            footer-bg-variant="transparent">

            <h6 v-if="tituloEdicao" class="mb-0 text-muted text-center font-weight-bold">{{tituloEdicao}}</h6>

            <b-embed
                class="mt-2"
                type="iframe"
                aspect="16by9"
                :src="url"
                v-if="edicao.documento_jornal.nome_minio && url"
                allowfullscreen
            >
            </b-embed>
            <p v-if="!edicao.documento_jornal.nome_minio && !carregando" class="mt-4 text-muted text-center ">Documento indisponível</p>

            <template v-slot:footer >
                <b-row >
                    <b-col class="text-left">
                        <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click.prevent="$router.push({ path: $route.meta.breadcrumb[$route.meta.breadcrumb.length - 2].to})"
                        >
                            <i class="fa fa-arrow-left pr-1" ></i> Voltar
                        </b-button>
                    </b-col>
                </b-row>
            </template>
        </b-card>
    </div>
</template>
<script>


import DataAtual from '../../components/DataAtual';
import Edicao from '../../models/Edicao'

export default {
    name: 'visualizacao',

    components: {
        DataAtual
    },

    data(){
        return {
            tituloEdicao: '',
            edicao: new Edicao(),
            url: '',
            carregando: true,
        }
    },

    methods: {
        obterEdicao(id){
            return this.$api.edicao.obterPublicado(id)
                .then(response => {
                    return response.data && response.data.success ? new Edicao(response.data.data) : null;
                });
        },
    },


    async mounted(){
        this.edicao = await this.obterEdicao(this.$route.params.id);
        if(this.edicao){
            this.tituloEdicao = "Edição: "+ this.edicao.numero_edicao +" | "+ this.$helper.getTipoEdicao(this.edicao.tipo_edicao) +" | Ano "+ this.edicao.ano_romanos_edicao + " | Publicada em: "+ this.$helper.formatDataBrasil(this.edicao.dt_publicacao);
            if(this.edicao.documento_jornal.nome_minio){
                this.$api.documento.downloadBlob(this.edicao.documento_jornal.nome_minio, this.edicao.documento_jornal.prefix)
                    .then(response => {
                        if(response.status === 200){
                            this.url = URL.createObjectURL(response.data);
                        }
                    });
            }
        }
    }
}
</script>
<style scoped>
   .breadcrumb{
        font-size: 0.9em;
    }
</style>